import React from 'react';
import ReactECharts from 'echarts-for-react';
import { useTheme } from '../contexts/ThemeContext';

const TaskChart = ({ tasks }) => {
  const completed = tasks.filter(task => task.completed).length;
  const pending = tasks.filter(task => !task.completed).length;
  const { darkMode } = useTheme();

  const option = {
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b}: {c} ({d}%)',
      backgroundColor: darkMode ? '#334155' : '#ffffff',
      borderColor: darkMode ? '#475569' : '#e2e8f0',
      textStyle: {
        color: darkMode ? '#f8fafc' : '#334155'
      }
    },
    legend: {
      orient: 'horizontal',
      bottom: '0%',
      left: 'center',
      textStyle: {
        color: darkMode ? '#cbd5e1' : '#64748b'
      }
    },
    series: [
      {
        name: 'Tasks',
        type: 'pie',
        radius: ['40%', '70%'],
        center: ['50%', '45%'],
        avoidLabelOverlap: false,
        label: {
          show: false,
          position: 'center',
          color: darkMode ? '#f8fafc' : '#334155'
        },
        emphasis: {
          label: {
            show: true,
            fontSize: '18',
            fontWeight: 'bold',
            color: darkMode ? '#f8fafc' : '#334155'
          }
        },
        labelLine: {
          show: false
        },
        data: [
          { 
            value: completed, 
            name: 'Completed',
            itemStyle: { color: '#10b981' }
          },
          { 
            value: pending, 
            name: 'Pending',
            itemStyle: { color: '#f59e0b' }
          }
        ]
      }
    ]
  };

  if (tasks.length === 0) {
    return (
      <div className="h-64 flex items-center justify-center text-slate-500 dark:text-slate-400">
        <p>No data to display</p>
      </div>
    );
  }

  return (
    <ReactECharts 
      option={option} 
      style={{ height: '250px' }}
      opts={{ renderer: 'svg' }}
      theme={darkMode ? 'dark' : undefined}
    />
  );
};

export default TaskChart;